<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('promo_codes')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'promo_code', true)"
                          @click="openModal()"
                          v-if="$can('add_package')"
      />
    </app-page-top-section>

    <app-table
        id="promo-code-table"
        :options="options"
        :card-view="false"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <div class="my-4 border-bottom w-100"></div>

    <promo-code-create-edit-modal
        v-if="isLocationCreateOpenModalActive || isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />

    <renew-subscription-modal
        v-if="renewSubscriptionModelEnabled"
        v-model="renewSubscriptionModelEnabled"
        :selected-url="selectedUrl"
        @close="renewSubscriptionModelEnabled = false"
    />

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('promo-code-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>
import PackageCreateEditModal from "./PackageCreateEditModal";
import {
  GET_PROMO_CODES
} from "../../../Config/ApiUrl";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import SwitchInput from "../../../../core/components/input/SwitchInput";
import RenewSubscriptionModal from "./RenewSubscriptionModal";
import PromoCodeCreateEditModal from "./PromoCodeCreateEditModal";
import PromoCodeMixin from "../../Mixins/PromoCodeMixin";

const {TENANTS} = require("../../../Config/ApiUrl");

export default {
  components: {PackageCreateEditModal, SwitchInput, RenewSubscriptionModal, PromoCodeCreateEditModal},
  mixins: [PromoCodeMixin],
  data() {
    this.fetchPromoCodes();
    return {
      isModalActive: false,
      selectedUrl: '',
      isLocationCreateOpenModalActive: false,
      promoCodes: [],
      TENANTS,
      renewSubscriptionModelEnabled: false,
    }
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    openRenewModel() {
      this.renewSubscriptionModelEnabled = true;
      console.log(this.renewSubscriptionModelEnabled);
    },
    deletePromoCode() {
      const response = axiosDelete(GET_PROMO_CODES)
    },
    fetchPromoCodes() {
      axiosGet(GET_PROMO_CODES)
          .then(response => {
            this.promoCodes = response.data;
          });
    },

    triggerActions(row, action, active) {
      console.log(action.key);
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${GET_PROMO_CODES}/${row.id}`;
        this.isModalActive = true;
      } else if (action.key === 'delete') {

      } else if (action.key === 'renew') {
        this.openRenewModel();
      } else {
        this.getAction(row, action, active)
      }

    },
  },
}
</script>

<style>
.pricing-table-tab p {
  color: #0B2B3C;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.pricing-table-tab ul {
  border-bottom: none;
  display: inline-block;
}

.pricing-table-tab ul .nav-item {
  display: inline-block;
}

.pricing-table-tab ul li button {
  text-transform: capitalize;
  padding: 5px 50px;
  position: relative;
  color: #949494;
  background: transparent;
  border: none;
  font-size: 18px;
  width: auto;
  border: none !important;
}

.pricing-table-tab ul li:first-child button {
  padding-left: 0 !important;
  padding-right: 35px;
}

.pricing-table-tab ul li:nth-child(2) button {
  padding-right: 0px;
}

.pricing-table-tab ul li button::before {
  position: absolute;
  content: "";
  width: 60px;
  height: 25px;
  background: #fff;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  right: -43px;
  top: 67%;
  margin-top: -20px;
  border: 1px solid #00ACD4 !important;
  z-index: 1;
}

.pricing-table-tab ul li button::after {
  position: absolute;
  content: "";
  width: 16px;
  height: 14px;
  background: #00ACD4;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  margin-top: -15px;
  z-index: 1;
  top: 69%;
  right: -32px;
  -webkit-transition: all ease .3s;
  -moz-transition: all ease .3s;
  transition: all ease .3s;
  animation-name: fadeInLeft;
  -webkit-animation-name: fadeInLeft;
  -moz-animation-name: fadeInLeft;
  animation-duration: .3s;
  -webkit-animation-duration: .3s;
  -moz-animation-duration: .3s;
}

.pricing-table-tab ul li:nth-child(even) button {
  text-align: right
}

.pricing-table-tab ul li:nth-child(even) button::before {
  left: -27px;
  right: auto
}

.pricing-table-tab ul li:nth-child(even) button::after {
  right: auto;
  left: -22px;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
  -moz-animation-name: fadeInRight;
  animation-duration: .3s;
  -webkit-animation-duration: .3s;
  -moz-animation-duration: .3s
}

.pricing-table-tab ul li button.active::after, .pricing-table-tab ul li button.active::before {
  display: none;
  z-index: -9
}

.pricing-table-tab ul li button.active {
  color: #00acd4 !important;
}

.pricing-item {
  background: var(--navbar-bg);
  text-align: center;
  /*border: 2px solid rgba(239, 239, 239, 0.93);*/
  border-color: inherit;
  border: 1px solid;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  max-width: 400px;
}

.pricing-btn button {
  background-image: linear-gradient(310deg, #00ACD4, #4ec6e2);
  padding: 10px 20px;
  border-radius: 50px;
  border: none;
}

/*.pricing-item:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0px 8px 17px 0px #eee;
}*/

.pricing-header {
  position: relative;
  padding: 30px 0px 50px 0px;
  z-index: 1;
  overflow: hidden;
}

.pricing-header::after {
  border-radius: 0 0 50% 50%;
  content: "";
  background-image: linear-gradient(310deg, #00ACD4, #4ec6e2);
  height: 100%;
  left: 0px;
  margin: 0 auto;
  opacity: .05;
  position: absolute;
  right: 0px;
  top: 0px;
  width: auto;
  z-index: -1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.pricing-item:hover .pricing-header::after {
  opacity: 1;
}

.pricing-item.active .pricing-header::after {
  opacity: 1;
}

.pricing-header h4 {
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 10px;
  line-height: 1.2;
  font-weight: 600;
  color: #00ACD4;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.pricing-item.active .pricing-header h4 {
  color: #fff;
}

.pricing-item:hover .pricing-header h4 {
  color: #fff;
}

.pricing-header h2 {
  font-size: 40px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.pricing-item:hover .pricing-header h2 {
  color: #fff;
}

.pricing-item.active .pricing-header h2 {
  color: #fff;
}

.pricing-header .badge {
  position: absolute;
  top: 20px;
  right: -37px;
  background: #0d0044;
  border-radius: 0px;
  text-transform: uppercase;
  font-size: 12px;
  padding: 8px 40px;
  transform: rotate(50deg);
}

.pricing-content {
  padding: 30px 0;
}

.pricing-content ul {
  padding: 0;
}

.pricing-content ul li {
  line-height: 30px;
  font-size: 15px;
  font-weight: 400;
  border-bottom: 1px dashed #eee;
  padding: 9px 0;
  list-style: none;
}

.pricing-content ul li:last-child {
  border-bottom: none;
}

.pricing-item .pricng-btn {
  margin-bottom: 40px;
}

/*Random*/
/*.tab-pane.fade.show {*/
/*  transform: translateY(0rem);*/
/*}*/

.tab-pane.fade {
  transition: all 0.6s ease-out;
  /*transform: translateY(1rem);*/
}

.turn_ideas_section {
  background: #eee;
  border-radius: 10px;
  padding: 50px 30px;
}

.trun_ideas_contetn {
  text-align: center;
}

.trun_ideas_contetn img {
  width: 90%;
  margin: 0 auto;
  text-align: center;
}

.trun_ideas_nav .nav-item {
  width: 100%;
  display: block;
}

.trun_ideas_nav ul {
  border: none;
}

.nav-item button {
  width: 100%;
  text-align: left;
  border: none !important;
  position: relative;
  color: #67748e !important;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 15px;
  padding: 25px 20px;
  border-radius: 5px;
  background: transparent !important;
}

.nav-item button:focus {
  outline: none;
}

.trun_ideas_nav .nav-item button i {
  font-size: 23px;
  padding-right: 7px;
  display: inline-block;
  float: left;
}

.trun_ideas_nav .nav-item button.active i {
  color: #00acd4;
}

.trun_ideas_nav .nav-item button::after {
  content: "";
  clear: both;
  display: block;
  position: absolute;
  width: 8px;
  height: 100%;
  top: 0;
  left: 0;
  background-image: linear-gradient(310deg, #00ACD4, #4ec6e2);
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  visibility: hidden;
  opacity: 0;
}

.trun_ideas_nav .nav-item button.active::after {
  visibility: visible;
  opacity: 1;
}

.trun_ideas_nav .nav-item button.active {
  color: #00acd4 !important;
}

.mb-30 {
  margin-bottom: 30px;
}

.line-through {
  text-decoration: line-through;
}

.mt-30 {
  margin-top: 5rem;
}

/*Random*/
</style>